<div class="modal-content">
  @if (modal()?.Title) {
    <p class="title">
      {{modal().Title}}
    </p>
  }
  @if (modal()?.Body) {
    @for (paragraph of modal()?.Body; track paragraph) {
      <p>
        {{paragraph}}
      </p>
    }
  }
  @if (modal()?.InfoLink) {
      <p>
        {{modal()?.InfoLinkBodyBeforeLink}} <a [href]="modal().InfoLink">{{modal()?.InfoLinkText??modal()?.InfoLink}}</a> {{modal()?.InfoLinkBodyAfterLink}}
      </p>
  }
</div>
<div class="modal-buttons">
  @if (modal()?.ActionOk) {
    <a tabindex="0" (click)="$event?.stopPropagation();modal()?.ActionOk()" class="yes-button modal-button" [class.long-text]="modal()?.ActionOkText">{{modal()?.ActionOkText ? modal()?.ActionOkText:"OK"}}</a>
  }
  @if (modal()?.ActionYes) {
    <a tabindex="0" (click)="$event?.stopPropagation();modal()?.ActionYes()" class="yes-button modal-button" [class.long-text]="modal()?.ActionYesText">{{modal()?.ActionYesText ? modal()?.ActionYesText:"Yes"}}</a>
  }
  @if (modal()?.ActionNo) {
    <a tabindex="0" (click)="$event?.stopPropagation();modal()?.ActionNo()" class="no-button modal-button" [class.long-text]="modal()?.ActionNoText">{{modal()?.ActionNoText ? modal()?.ActionNoText:"No"}}</a>
  }
</div>
